import { Component, OnInit, ViewChild } from '@angular/core';
import { MensagemService, ProgressoService } from 'maestro-ng';
import { OrgaoJusticaFrmComponent } from '../orgao-justica-frm/orgao-justica-frm.component';
import { OrgaoJustica } from '../orgao-justica.model';
import { OrgaoJusticaService } from '../orgao-justica.service';

@Component({
  selector: 'app-orgao-justica-edicao',
  templateUrl: './orgao-justica-edicao.component.html',
  styleUrls: ['./orgao-justica-edicao.component.css'],
})
export class OrgaoJusticaEdicaoComponent implements OnInit {
  @ViewChild(OrgaoJusticaFrmComponent, { static: true })
  frm!: OrgaoJusticaFrmComponent;

  entidade: OrgaoJustica;

  constructor(
    private service: OrgaoJusticaService,
    private mensagemService: MensagemService,
    private progressoService: ProgressoService
  ) {}

  ngOnInit(): void {}
}
